<template>
  <div>
    <el-breadcrumb class="app-breadcrumb" separator="/">
      <el-breadcrumb-item>
        <span @click="$router.push(beforeItem.to)" class="redirect">{{ beforeItem.name }}</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <span class="no-redirect">{{afterItem}}</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
  props: {
    beforeItem: {
      type: [Object],
      required: true
    },
    afterItem: {
      type: [String],
      required: true
    }
  },
  methods: {}
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  padding: 10px 0;
  display: inline-block;
  font-size: 14px;
  margin-left: 10px;
  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
  .redirect {
    font-weight: 700;
    text-decoration: none;
    color: #303133;
    transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  }
  .redirect:hover {
    color: #70af00;
    cursor: pointer;
  }
}
</style>
